import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

/**
 * Schützt Routen, die Führungskraft- oder Admin-Rechte erfordern.
 * Vertriebs-User werden auf das Dashboard zurückgeleitet.
 */
export function FuehrungskraftRoute({ children }) {
  const { isAuthenticated, isFuehrungskraftOrAdmin } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!isFuehrungskraftOrAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}
